import { LegalShell, SUPPORT_EMAIL } from "@/components/LegalShell";
import { Mail, LifeBuoy, MessageSquare, Clock } from "lucide-react";

const CARDS = [
  { icon: LifeBuoy, title: "Support", desc: "Trouble with your account, billing or a calculation? We're here to help.", email: SUPPORT_EMAIL },
  { icon: MessageSquare, title: "Feedback & ideas", desc: "Missing a pay type or feature? Tell us what would make MyPayAlert better.", email: SUPPORT_EMAIL },
];

export default function Contact() {
  return (
    <LegalShell
      title="Contact us"
      subtitle="Have a question, found a bug, or want to suggest a feature? We'd love to hear from you."
    >
      <div data-testid="contact-content" className="space-y-8">
        <a
          href={`mailto:${SUPPORT_EMAIL}`}
          data-testid="contact-email-primary"
          className="flex items-center gap-4 rounded-2xl bg-white/5 border border-white/10 p-6 hover:border-blue-500/60 transition-colors"
        >
          <div className="h-12 w-12 rounded-xl bg-blue-600 flex items-center justify-center shrink-0"><Mail className="h-6 w-6 text-white" /></div>
          <div>
            <p className="text-sm text-slate-400">Email us directly</p>
            <p className="text-xl font-black text-white">{SUPPORT_EMAIL}</p>
          </div>
        </a>

        <div className="grid sm:grid-cols-2 gap-4">
          {CARDS.map(({ icon: Icon, title, desc, email }) => (
            <div key={title} className="rounded-2xl bg-white/5 border border-white/10 p-6">
              <Icon className="h-6 w-6 text-blue-400 mb-3" />
              <p className="text-white font-bold">{title}</p>
              <p className="text-sm text-slate-400 mt-1.5">{desc}</p>
              <a href={`mailto:${email}`} className="inline-block text-sm text-blue-400 hover:text-blue-300 mt-3">{email}</a>
            </div>
          ))}
        </div>

        <div className="flex items-start gap-3 rounded-xl bg-white/5 border border-white/10 p-5">
          <Clock className="h-5 w-5 text-emerald-400 shrink-0 mt-0.5" />
          <p className="text-sm text-slate-400">We typically reply within <span className="text-slate-200">1–2 business days</span>. Please include your account email and a description of what you were doing so we can help faster.</p>
        </div>
      </div>
    </LegalShell>
  );
}
